// Country is stored as an ISO code ("IE") on new records, but legacy data may hold a name
// ("Ireland" / "Eire") — accept those too.
const IRISH_COUNTRY_VALUES = new Set(["IE", "IRL", "IRELAND", "EIRE"]);

/**
 * Whether an address should be treated as Irish.
 *
 * Blank or unknown counts as Irish. Many existing records have no country set and are
 * overwhelmingly Irish, so treating "unset" as foreign would relax county and Eircode rules
 * on most of the patient base — the opposite of what the caller wants. Only an explicitly
 * non-Irish country changes behaviour.
 *
 * Lives here rather than under a feature because two unrelated callers need the same answer:
 * CDM refuses non-Irish patients outright, and the address form stops offering Irish counties
 * and an Eircode for them.
 */
export const isIrishCountry = (country) => {
  const normalized = String(country ?? "")
    .trim()
    .toUpperCase();

  if (!normalized) return true;

  return IRISH_COUNTRY_VALUES.has(normalized) || normalized.startsWith("IRELAND");
};
